<div class="stripe-add-credit-card">
  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center p-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="ms-3">Loading payment form...</span>
    </div>
  }

  @if (errorMessage()) {
    <div class="alert alert-danger" role="alert">
      <fa-duotone-icon icon="triangle-exclamation" class="me-2"></fa-duotone-icon>
      {{ errorMessage() }}
    </div>
  }

  <div #paymentElementContainer [class.d-none]="isLoading()"></div>

  @if (!isLoading()) {
    <div class="d-flex justify-content-end gap-2 mt-3">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()" [disabled]="isSaving()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="savePaymentMethod()"
        [disabled]="isSaving() || !isPaymentElementReady()">
        @if (isSaving()) {
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          Saving...
        } @else {
          Save Payment Method
        }
      </button>
    </div>
  }
</div>
